module.exports = __webpack_public_path__ + "img/collectible-card-error-image.5bf8ca62.png";